<template>
    <v-card >
      <v-container v-if="sumfurush_card">
        <v-card-title class="pa-0 mb-2">Движение денежных средств
          <v-divider class="mx-2" inset vertical></v-divider>
          <export-excel
          :data="filteredDDS"
          :worksheet="'ДДС '"
          :name="'ДДС'"
          :title="'Движение денежных средств'"
          :fields="json_fields"
          :auto-width="true"
          >
          <v-icon  color="success" >
              mdi-microsoft-excel
              </v-icon>
      </export-excel>

        </v-card-title>
        <v-row class="mb-2">
          <v-col cols="12" md="3">



            <v-menu class="m-2"
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date1"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date1"
                label="Дата 1"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date1"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="get_karz"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>



            <!--
            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Метод оплата"
            hide-details
            multiple
            solo
            :items="gnakds"
            item-text="nom"
            item-value="nom"
            class="m-4"
            @click:clear="get_karz"
            v-model="filters.nom_gnakd" /> -->


          </v-col>

          <v-col cols="12" md="3">

            <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="date2"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date2"
                label="Дата 2"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu2 = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="get_karz"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>


            <!-- <v-autocomplete class="m-4"
            clearable
             item-color="primary"
             color="primary"
             hide-no-data
             hide-details
             multiple
             solo

             :items="valutaho"
             item-text="valuta"
             item-value="valuta"
             label="Валюта"
             @click:clear="get_karz"
             v-model="filters.valuta" /> -->



          </v-col>
          <v-col cols="12" md="3">


            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Операция"
            hide-details
            multiple
            solo
            :items="oprs"
            item-text="opr"
            item-value="opr"
            @click:clear="get_karz"
            v-model="filters.opr" />

          </v-col>

          <v-col cols="12" md="3">


            <v-text-field
            color="primary"
            prepend-inner-icon="mdi-magnify"
            solo
            v-model="search"
            label="Поиск"/>

        </v-col>

        </v-row>

        <v-data-table
        :headers="headers"
        :items="filteredDDS"
        class="elevation-1"
        :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [ 7, 20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
        :search="search">


          <template slot="body.append">
              <tr>
                  <th class="title "></th>
                  <th class="title "></th>
                  <th class="title ">{{Number( sumDolg('debit')).toFixed(2) }}</th>
                  <th class="title ">{{Number( sumDolg('kredit')).toFixed(2) }}</th>
                  <th style="color:green" class="title "> Остаток кассы: {{Number( Number( sumDolg('debit')).toFixed(2) - Number( sumDolg('kredit')).toFixed(2) ).toFixed(2) }}</th>
              </tr>
          </template>

        </v-data-table>
      </v-container>






      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>
export default {

data: () => ({



  searching: "",
  search: "",


      date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,


firma_info:{},

filters: {
    fio: "",
    nom: "",
    valuta: "",
    firma: "",
    comment: "",
    opr:"",
    nom_gnakd:"",
    namud_pardokht:""
},

karzdoron: [],

headers: [

        { text: 'Дата', value: 'SANA' },
        { text: 'Операция', value: 'opr' },
        { text: 'Дебит', value: 'debit' },
        { text: 'Кредит', value: 'kredit' },
        { text: 'Описание', value: 'ezoh' },



],

    json_fields: {

        'Дата': 'SANA',
        'Операция': 'opr' ,
        'Дебит': 'debit' ,
        'Кредит': 'kredit' ,
        'Описание': 'ezoh' ,
 
    },

oprs:[
    {opr:"Прием смена"},
    {opr:"Приход денег в кассу"},
    {opr:"Расход денег из кассы"},
    {opr:"Оплата поставщику"},
],


snack: false,
    snackColor: '',
    snackText: '',

loading: false,

furush_card: false,
sumfurush_card: true,
firmaho: [],
vipiska:[],
id_firma:0,

ost_na_nachalo:0,
summa_pokupka:0,
summa_skidka:0,
summa_oplata:0,
summa_vozvrat:0,
ost_dolga:0,
karz_firma:0,
kharid:[],
vozvrat:[],
id:0,

info_pardokht:{},
delete_dialog: false,
edit_dialog: false,



  










}),

mounted(){



  this.get_karz();

},

methods: {


  sumDolg(key) {
  return  this.filteredDDS.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },
  sumVipiska(key) {
  return  this.filteredVipiska.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },

  get_karz(){
    this.loading = true;

          this.$refs.menu.save(this.date1)
          this.$refs.menu2.save(this.date2)

    this.karzdoron = [];

    axios.post('/api/get_dds',{start:this.date1, end:this.date2},
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                    this.karzdoron = response.data.dds
                                    this.loading = false;
                                  //  console.log(response.data.dds)
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Не удалось получить данные"
                                    this.karzdoron = [];
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                this.karzdoron = [];
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                console.log(error.response.data.message)
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });
  },













},


computed: {

    filteredDDS() {
    let filter = this.karzdoron.filter((ID) => {
    for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false
    let dropdownValue = ID[key];
    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},



}

}
</script>

<style  scoped>

</style>



